import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SetDefaultPlanForKindMutationVariables } from '@/gql/graphql';

export const setDefaultPlanForKind = async (variables: SetDefaultPlanForKindMutationVariables) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation SetDefaultPlanForKind($id: String!) {
        setDefaultPlanForKind(id: $id) {
          id
          name
          kind
          amount
          isActive
          hasTrial
          trialPrice
          tier
          isDefault
          fragmentInto
          defragmentInto
          upgradeInto
          data
        }
      }
    `),
    variables,
  });

  if (!response.data?.setDefaultPlanForKind) {
    throw new Error('Failed to set default plan');
  }

  return response.data.setDefaultPlanForKind;
};
